import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const CustomCard = ({ icon, title, description }: CustomCardProps) => {
  return (
    <div className={classNames(styles.mainEnclosure, "grid")}>
      <div className={classNames(styles.icon)}>{icon}</div>
      <div className={classNames(styles.textEnclosure, "grid")}>
        <h4 className={classNames(styles.enclosureTitle)}>{title}</h4>
        <p className={classNames(styles.enclosureDescription)}>{description}</p>
      </div>
    </div>
  );
};

export default CustomCard;
